import { useSelector } from 'react-redux';

import {
  selectCurrentUser,
} from '../../../layouts/AdminLayout/slice/selectors';
import { selectCurrentProduct } from '../../../layouts/MainLayout/slice/selectors';

export function useAdminDashboardContext() {
  const currentProduct = useSelector(selectCurrentProduct);
  const currentUser = useSelector(selectCurrentUser);


  return {
    currentProduct,
    currentUser,
  };
}

